import { render, staticRenderFns } from "./RegisterStep1.vue?vue&type=template&id=0072b7fc&scoped=true"
import script from "./RegisterStep1.vue?vue&type=script&lang=js"
export * from "./RegisterStep1.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep1.vue?vue&type=style&index=0&id=0072b7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072b7fc",
  null
  
)

export default component.exports